"use strict";

require("core-js/modules/es6.object.define-property");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var components_1 = require("@lsg/components");

var RichTextRenderer_1 = require("../../../RichTextRenderer");

var util_1 = require("../../util");

exports.renderCheckmarkListItem = function (entryAccessor) {
  var text = entryAccessor.richText('text');
  return text && React.createElement(components_1.Paragraph, null, React.createElement(components_1.Icon, {
    color: components_1.Icon.Colors.PRIMARY,
    name: components_1.Icon.Names.interaction___checkmark
  }), React.createElement("b", {
    style: {
      marginLeft: '12px'
    }
  }, React.createElement(RichTextRenderer_1.ContentfulRichTextRenderer, {
    content: text,
    options: util_1.footnotesFragmentsOptions
  })));
};